import { api } from "./client";

/**
 * Strip empty fields so we don't send noise like `qty_min: null` to Mongo.
 */
function cleanColumnFilters(cf) {
  if (!cf) return undefined;
  const out = {};
  if (cf.date_from) out.date_from = cf.date_from;
  if (cf.date_to) out.date_to = cf.date_to;
  if (cf.employee_search) out.employee_search = cf.employee_search;
  if (cf.employee_ids?.length) out.employee_ids = cf.employee_ids;
  if (cf.transaction_types?.length) out.transaction_types = cf.transaction_types;
  if (cf.item_search) out.item_search = cf.item_search;
  if (cf.qty_min != null && cf.qty_min !== "") out.qty_min = Number(cf.qty_min);
  if (cf.qty_max != null && cf.qty_max !== "") out.qty_max = Number(cf.qty_max);
  if (cf.order_search) out.order_search = cf.order_search;
  return Object.keys(out).length ? out : undefined;
}

const reports = {
  kpis: (filters, config) => api.post("/reports/kpis", filters, config),
  ranking: (filters, limit = 20, config) =>
    api.post(`/reports/ranking?limit=${limit}`, { ...filters, limit }, config),
  comparativo: (filters, employee_ids_compare = []) =>
    api.post("/reports/comparativo", { ...filters, employee_ids_compare }),
  tendencia: (filters, granularity = "day", series_by = "transaction_type", config) =>
    api.post("/reports/tendencia", { ...filters, granularity, series_by }, config),
  distribucion: (filters, config) => api.post("/reports/distribucion-tipo", filters, config),
  heatmap: (filters) => api.post("/reports/heatmap", filters),
  tabla: (filters, opts = {}) =>
    api.post("/reports/tabla", {
      ...filters,
      page: opts.page ?? 1,
      page_size: opts.page_size ?? 50,
      sort_by: opts.sort_by ?? "timestamp",
      sort_dir: opts.sort_dir ?? "desc",
      search: opts.search ?? null,
      column_filters: cleanColumnFilters(opts.column_filters),
    }),
  tablaExport: (filters, opts = {}, format = "xlsx") =>
    api.post(
      `/reports/tabla/export?format=${format}`,
      {
        ...filters,
        page: 1,
        page_size: 500,
        sort_by: opts.sort_by ?? "timestamp",
        sort_dir: opts.sort_dir ?? "desc",
        search: opts.search ?? null,
        column_filters: cleanColumnFilters(opts.column_filters),
      },
      { responseType: "blob" }
    ),
  ganador: (filters, period = "month", date_anchor = null, mode = "volume", config) =>
    api.post("/reports/ganador-del-mes", { ...filters, period, date_anchor, mode }, config),
  efficiency: (filters, sort_by = "tx_per_hour", hours_source = "AUTO") =>
    api.post("/reports/efficiency", { ...filters, sort_by, hours_source }),
  threeD: (filters, view = "bars", top_n = 20) =>
    api.post("/reports/3d", { ...filters, view, top_n }),
  typeComparison: (filters, opts = {}) =>
    api.post("/reports/type-comparison", {
      ...filters,
      type_a: opts.type_a ?? "RF PICK",
      type_b: opts.type_b ?? "RF STAGE",
      granularity: opts.granularity ?? "month",
      breakdown: opts.breakdown ?? "total",
      metric: opts.metric ?? "count",
    }),
};

export default reports;
